export default __webpack_public_path__ + "static/media/0143.459139fe.jpg";